module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('Container', {
    attrs: {
      "drag-handle-selector": ".column-drag-handle",
      "drop-placeholder": _vm.dropItemPlaceholderOptions,
      "lock-axis": 'y'
    },
    on: {
      "drop": function($event) {
        _vm.onCategoryDrop($event)
      },
      "drag-start": _vm.dragStart
    }
  }, _vm._l((_vm.categories), function(c) {
    return _c('Draggable', {
      key: c.token
    }, [_c('div', {
      staticClass: "column-drag-handle text-left icon-list"
    }, [_c('i', {
      class: c.icon
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-list-content"
    }, [_vm._v("\n\t    \t\t\t\t\t\t\t\t\t" + _vm._s(c.name) + " (" + _vm._s(c.blogs.length) + ")\n\t    \t\t\t\t\t\t\t\t")])])])
  }))], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.blog == '') ? _c('div', {
    staticClass: "widget-wrap",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "pull-left pointer"
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.category.name))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-pencil-alt"
  }), _vm._v(" (" + _vm._s(_vm.category.blogs.length) + ")")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "widget-container margin-top-0"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "task-widget"
  }, [_c('Container', {
    staticClass: "widget-task-list todo-tasklist",
    attrs: {
      "drag-handle-selector": ".column-drag-handle",
      "lock-axis": 'y',
      "drop-placeholder": _vm.dropItemPlaceholderOptions
    },
    on: {
      "drop": function($event) {
        _vm.onItemDrop($event)
      },
      "drag-start": _vm.dragStart
    }
  }, _vm._l((_vm.category.blogs), function(b) {
    return _c('Draggable', {
      key: b.token,
      staticClass: "task-entry p-2 pl-4 pr-4"
    }, [_c('div', {
      staticClass: "column-drag-handle text-left task-intro",
      on: {
        "click": function($event) {
          _vm.blog = b
        }
      }
    }, [_c('div', {
      staticClass: "row align-items-center"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('h5', {
      staticClass: "m-0"
    }, [(b.locked) ? _c('i', {
      staticClass: "fa fa-lock"
    }) : _vm._e(), _vm._v(" " + _vm._s(b.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_c('img', {
      staticClass: "avatar-size",
      attrs: {
        "src": b.user.avatar
      }
    }), _vm._v(" " + _vm._s(b.user.name) + "\n\t\t\t    \t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_vm._v("\n\t\t\t    \t\t\t\t\t\t\t\t\t\t" + _vm._s(b.created_at) + "\n\t\t\t    \t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_c('i', {
      staticClass: "fas fa-eye"
    }), _vm._v(" " + _vm._s(b.views) + "\n\t\t\t    \t\t\t\t\t\t\t\t\t")])])])])
  }))], 1)])])]) : _c('div', {
    staticClass: "widget-wrap",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "pull-left pointer"
  }, [_c('h3', [_vm._v(_vm._s(_vm.category.name) + " "), _c('i', {
    staticClass: "fas fa-chevron-right"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.blog.name))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-pencil-alt"
  })])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "widget-container margin-top-0"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "task-widget"
  }, [_c('Container', {
    staticClass: "widget-task-list todo-tasklist",
    attrs: {
      "drag-handle-selector": ".column-drag-handle",
      "lock-axis": 'y',
      "drop-placeholder": _vm.dropItemPlaceholderOptions
    },
    on: {
      "drop": function($event) {
        _vm.onItemDrop($event)
      },
      "drag-start": _vm.dragStart
    }
  }, _vm._l((_vm.category.blogs), function(blog) {
    return _c('Draggable', {
      key: blog.token,
      staticClass: "task-entry p-2 pl-4 pr-4"
    }, [_c('div', {
      staticClass: "column-drag-handle text-left task-intro"
    }, [_c('div', {
      staticClass: "row align-items-center"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('h5', {
      staticClass: "m-0"
    }, [(blog.locked) ? _c('i', {
      staticClass: "fa fa-lock"
    }) : _vm._e(), _vm._v(" " + _vm._s(blog.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_c('img', {
      staticClass: "avatar-size",
      attrs: {
        "src": blog.user.avatar
      }
    }), _vm._v(" " + _vm._s(blog.user.name) + "\n\t\t\t    \t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_vm._v("\n\t\t\t    \t\t\t\t\t\t\t\t\t\t" + _vm._s(blog.created_at) + "\n\t\t\t    \t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_c('i', {
      staticClass: "fas fa-eye"
    }), _vm._v(" " + _vm._s(blog.views) + "\n\t\t\t    \t\t\t\t\t\t\t\t\t")])])])])
  }))], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('h3', [_vm._v("知識分類 \n\t\t              \t"), _c('a', {
    staticClass: "btn btn-default pull-right btn-xs text-gray",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-wrap"
  }, [_c('strong', {
    staticClass: "text-success"
  }, [_vm._v("知識庫是企業的軟性資產")]), _vm._v(" "), _c('p', [_vm._v("累積各種產業知識，相關作法、SOP、員工教育訓練..等等重要知識性文件，將可大幅減少相關支出，同時累積企業的內部價值")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-danger pull-right btn-xs",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default pull-right btn-xs text-gray mr-3",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-danger pull-right btn-xs",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-516df843","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KnowledgeBase/KnowledgeBaseBoard.vue
// module id = 688
// module chunks = 4